import profile from '@/config/profile';
import { calculateYearsOfExperience } from '@/utilities/common/generic';
import React, { useState, useEffect, useRef } from 'react';

const HistorySection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const isLightTheme = profile?.theme === 'light';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);


  return (
    <section 
      ref={sectionRef}
      className="min-h-screen flex flex-col justify-center px-8 py-20"
    >
      <div className="max-w-4xl mx-auto w-full">
        <h2 className={`text-sm font-light tracking-widest mb-16 transition-all duration-1000 transform ${
          isLightTheme ? 'text-slate-600' : 'text-gray-400'
        } ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          HISTORY
        </h2>
        
        <div className="space-y-12">
          {profile?.experiences?.map((exp, index) => (!exp?.title ? null :
            <div
              key={exp.year}
              className={`flex items-center justify-between border-b pb-8 group hover:border-blue-500 transition-all duration-500 cursor-pointer ${
                isLightTheme ? 'border-slate-300' : 'border-gray-800'
              } ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
              }`}
              style={{ transitionDelay: `${exp.delay}ms` }}
            >
              <div className="flex items-center space-x-8">
                <div className={`text-6xl md:text-7xl font-bold transition-all duration-500 group-hover:scale-110 ${
                  exp?.isActive ? 'text-blue-500' : isLightTheme ? 'text-slate-900 group-hover:text-blue-500' : 'text-white group-hover:text-blue-400'
                }`}>
                  {exp?.year}
                </div>
                
                <div>
                  <h3 className={`text-2xl md:text-3xl font-bold transition-colors duration-300 ${
                    isLightTheme ? 'text-slate-900 group-hover:text-blue-500' : 'text-white group-hover:text-blue-400'
                  }`}>
                    {exp?.title}
                  </h3>
                  <p className={`transition-colors duration-300 ${
                    isLightTheme ? 'text-slate-600 group-hover:text-slate-700' : 'text-gray-400 group-hover:text-gray-300'
                  }`}>
                    {exp?.company}
                  </p>
                </div>
              </div>
              
              <div className="hidden md:block">
                <div className={`w-4 h-4 rounded-full border-2 group-hover:border-blue-500 group-hover:bg-blue-500 transition-all duration-300 ${
                  isLightTheme ? 'border-slate-400' : 'border-gray-600'
                }`}></div>
              </div>
            </div>
          ))}
        </div>
        
        <div className={`mt-20 text-center transition-all duration-1000 delay-1000 transform ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
        }`}>
          <p className={`text-lg ${isLightTheme ? 'text-slate-600' : 'text-gray-400'}`}>
            {/* profile?.experiences?.[profile?.experiences?.length-1]?.year is a string I need to calculate the years of experience based on current year */}
            With over {calculateYearsOfExperience()} years of experience in {profile.journey[Math.floor(Math.random() * profile.journey.length)]}.
            {profile?.specialty ? `I specialize in delivering ${profile?.specialty?.join(', ')}.` : null}
            My journey reflects a commitment to innovation {profile?.journey ? `, ${profile?.journey?.join(', ')}` : null}and excellence in the tech industry.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HistorySection;